import { render, staticRenderFns } from "./DesignProductForm.vue?vue&type=template&id=047ad9c6&scoped=true&"
import script from "./DesignProductForm.vue?vue&type=script&lang=js&"
export * from "./DesignProductForm.vue?vue&type=script&lang=js&"
import style0 from "./DesignProductForm.vue?vue&type=style&index=0&id=047ad9c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047ad9c6",
  null
  
)

export default component.exports